import AnimatedBackgroundV2 from "components/AnimatedBackground/AnimatedBackground";

export default AnimatedBackgroundV2;
